export var getCurrentManifest = function (state) { return state.manifest.currentManifest; };
export var getManifests = function (state) { return state.manifest.manifests; };
export var getFiles = function (state) { return state.manifest.files; };
export var getManifestsNumber = function (state) { return state.manifest.manifestsNumber; };
//# sourceMappingURL=manifest.js.map